import React, { Component } from 'react';
import { FloatingLabel, Form } from 'react-bootstrap';

class ScreenerSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            label: this.props.label,
            options: this.props.options,
            onChange: this.props.onChange,
            value: this.props.value
        };
        console.log('screenerselect value', this.state.value);
    }

    renderRow(listValue) {
        return (
            <option key={listValue.value} value={JSON.stringify(listValue.labelKey)}>{listValue.value}</option>
        )
    }

    render() {
        let tmpValue = this.state.value;
        if (this.state.value === undefined){
            tmpValue = '';
        }
        return ( 
            <FloatingLabel controlId="floatingSelectGrid" label={this.state.label}>
                <Form.Select aria-label="Floating label select" onChange={this.state.onChange} value={JSON.stringify(tmpValue.labelKey)}>
                    {this.state.options.map(this.renderRow.bind(this))}
                </Form.Select>
            </FloatingLabel>
        );
    }
}

export default ScreenerSelect;
